import * as _ from "lodash-es";

const ButtonDisplayMode = {
  DEFAULT: "default",
  ALWAYS: "always",
  DISABLE_IF_NOT_LAST: "disableIfNotLast",
};

export default function isDisabledButton(that: any, button: any) {
  const disableButtonReuse: boolean = _.get(that, "settings.disableButtonReuse");
  const messages = _.get(that, "$store.getters.messages", []);
  const isSendingPostback: boolean = _.get(that, "$store.getters.isSendingPostback");
  const shouldDisableIfInLivechat: boolean = that.shouldDisableIfInLivechat;
  const replyMessages = messages.filter(
    (message: any) => message.type === "reply" && !message?.options?.excludeFromReplyMessages
  );

  // check button display mode
  const buttonDisplayMode = _.get(
    that,
    "message.options.buttonDisplayMode",
    ButtonDisplayMode.DEFAULT
  );
  const disableButtonIfNotLast =
    buttonDisplayMode === ButtonDisplayMode.DISABLE_IF_NOT_LAST ||
    (buttonDisplayMode === ButtonDisplayMode.DEFAULT && !that?.settings?.alwaysEnableButton);

  const isLastMessage = that.message.id === (_.last(replyMessages) as any)?.id;
  if (isLastMessage) {
    return false;
  }

  // Match any livechat start trigger
  const isHandoverLivechatStart = JSON.stringify(button).match(
    /(handover_livechat_start|handover_router)/
  );

  // Match any livechat stop trigger
  const isHandoverLivechatStop = JSON.stringify(button).match(/handover_stop/);

  const isDisabled: boolean =
    isSendingPostback ||
    (disableButtonReuse && !!isHandoverLivechatStart) ||
    (shouldDisableIfInLivechat && !isHandoverLivechatStop) ||
    disableButtonIfNotLast;

  return isDisabled;
}
